import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type EnrollmentProfileMissingDocuments = {
  childInfo: boolean
  identityDocuments: boolean
  secureIdentityPicture: boolean
  healthDocuments: boolean
  pickupInformation: boolean
  languageTest: boolean
  otoTravelInformation: boolean
}

export function getEnrollmentProfileMissingDocuments(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentProfileMissingDocuments.url, { id }))
    .get<EnrollmentProfileMissingDocuments>()
}
